// extracted by css-extract-rspack-plugin
export default {"plate":"plate--elBG9pOY44LCyaiR","inline":"inline--sbtEMVgXqgU1JcPW","content":"content--Gtj9U6PYzyIWEQrk","text":"text--hM11_xGGyX4mffnc"};